import { useState } from 'react'
import useTranslation from 'next-translate/useTranslation'

interface IProps {
  [x: string]: any
  handleMinSalaryChange: (value: number) => void
}

const MinSalaryInput = ({ handleMinSalaryChange, ...rest }: IProps) => {
  const { t } = useTranslation('common')
  const [isHidden, setIsHidden] = useState(false)
  const [value, setValue] = useState('')

  const handleOnValueChange = (val: any) => {
    setValue(val)
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    handleMinSalaryChange(parseFloat(value))
    setIsHidden(true)
  }

  return (
    <form
      onSubmit={(e) => {
        handleSubmit(e)
      }}
      className={`min-salary-input pb-10 ${isHidden ? 'hidden' : ''}`}
    >
      <p className='text-c22 xl:text-md font-light xl:pr-3 pb-5'>
        {t('common:see_if_offer_matches')}
      </p>
      <div className='flex justify-between flex-row flex-wrap'>
        <input
          type='text'
          value={value}
          onChange={(e) => {
            handleOnValueChange(e.target.value)
          }}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault()
            }
          }}
          placeholder={t('common:min_salary_placeholder')}
          className='as-currency mb-4 w-full h-full lg:w-[300px] xl:h-[40px] xl:py-2 border-2 transition duration-300 bg-white py-3 px-5 flex items-center justify-between rounded-lg'
        />
        <input
          type='submit'
          value={t('common:check_salary')}
          className='w-full lg:w-[300px] xl:h-[40px] xl:py-2 xs:py-2 py-3 flex items-center justify-center focus:outline-none transition ease-in-out duration-300 cursor-pointer rounded-full  whitespace-nowrap relative inline-block px-7 border-2 border-black hover:bg-gray-dark'
        />
      </div>
    </form>
  )
}

export default MinSalaryInput
